import apiService from "./apiService";
import AppConstants from "../appConstants";

class CommodityService {
    getAllCommodity(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_COMMODITY_GETALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getCommodityDetails(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_COMMODITY_DETAIL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerCommodity(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_COMMODITY_REGISTER, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteCommodity(params) {
        return new Promise((resolve, reject) => {
            apiService.delete(AppConstants.URL_COMMODITY_DELETE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_COMMODITY_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new CommodityService();
